import React, { FC } from 'react';
import styled from 'styled-components';

import { Match, Matches } from '../../../../../database.schema';
import { MatchPlayer } from './match-player';

export const TeamWrapper = styled.div<{ bgColor?: string | null }>`
  border: 1px solid black;
  width: 8rem;
  background: ${(props) => props.bgColor || '#eae6e6'};
  color: white;
  padding: 5px;
  min-height: 2rem;
  margin: 0.25rem 0;
  text-align: center;
`;
const DropWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 20rem;
`;

type Props = {
  resultsHolder: Matches;
};

export const MatchEntrySingles: FC<Props> = ({ resultsHolder }): JSX.Element | null => {
  return (
    <div>
      {resultsHolder.matches.map((_: Match, index: number) => (
        <div key={`result-${index}`}>
          <h3>{`Singles Match ${index + 1}`}</h3>
          <DropWrapper data-testid={`singles-${index}`}>
            <MatchPlayer dndId={`team1Single-${index}`} playerId={resultsHolder.matches[index].team1.players?.[0].playerId} team="team1-1" bgColor="red" matchIndex={index} />
            <MatchPlayer dndId={`team2Single-${index}`} playerId={resultsHolder.matches[index].team2.players?.[0].playerId} team="team2-1" bgColor="blue" matchIndex={index} />
          </DropWrapper>
        </div>
      ))}
    </div>
  );
};
